<template>
  <div class='sub-page sub-page-leftmenu'>
    <div class='sub-content'> <!-- 여기까지 page header 이하 수정해서 사용-->
      <div class="summary-wrap">
        <CustomerSummaryComponent/>
      </div>
      <div class="summary-wrap">
        <PositionSummaryComponent/>
      </div>
      <div class="summary-wrap">
        <ApplicantSummaryComponent/>
      </div>
      <loading :active.sync="isLoading" color='rgb(2, 110, 156)' loader='bars'></loading>
    </div>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import ConstDef from '../../share/ConstDef'
import CustomerSummaryComponent from './CustomerSummaryComponent.vue'
import PositionSummaryComponent from './PositionSummaryComponent.vue'
import ApplicantSummaryComponent from './ApplicantSummaryComponent.vue'

export default {
  name: 'home',
  data: function () {
    return {
      isLoading: false

    }
  },
  components: {
    Loading,
    CustomerSummaryComponent,
    PositionSummaryComponent,
    ApplicantSummaryComponent

  },
  created () {
    document.title = ConstDef.WEB_TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
    }
  },
  mounted () {

  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {

  }
}
</script>

<style lang="scss">
  .summary-wrap{
    margin-bottom: 20px;
  }
</style>
